import { useState } from "react";
import { T } from "../utils/theme";
import { Bell, Settings, Search, RefreshCw } from "lucide-react";

const TopBar = ({ title, subtitle, onRefresh, loading }) => {
  const [search, setSearch] = useState("");
  const now = new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  return (
    <div style={{
      padding: "14px 28px",
      borderBottom: `1px solid ${T.border}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: T.surface,
      flexShrink: 0,
    }}>
      {/* Left */}
      <div>
        <h1 style={{ fontFamily: T.display, fontWeight: 800, fontSize: 18, color: T.text, lineHeight: 1.2 }}>{title}</h1>
        <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{subtitle || now}</div>
      </div>

      {/* Right */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {/* Search */}
        <div style={{
          display: "flex", alignItems: "center", gap: 8,
          background: T.card, border: `1px solid ${T.border}`,
          borderRadius: 10, padding: "8px 14px",
        }}>
          <Search size={13} color={T.muted} />
          <input
            value={search} onChange={e => setSearch(e.target.value)}
            placeholder="Recherche globale..."
            style={{
              background: "none", border: "none", width: 180,
              fontSize: 12, padding: 0, color: T.text,
            }}
          />
        </div>

        {/* Refresh */}
        {onRefresh && (
          <button onClick={onRefresh} className="btn btn-ghost btn-icon" title="Actualiser">
            <RefreshCw size={14} className={loading ? "spin" : ""} color={T.textSub} />
          </button>
        )}

        {/* Notifs */}
        <div style={{ position: "relative" }}>
          <button className="btn btn-ghost btn-icon">
            <Bell size={15} color={T.textSub} />
          </button>
          <div style={{
            position: "absolute", top: 6, right: 6,
            width: 8, height: 8, background: T.red,
            borderRadius: "50%", border: `2px solid ${T.surface}`,
          }} />
        </div>

        {/* Settings */}
        <button className="btn btn-ghost btn-icon">
          <Settings size={15} color={T.textSub} />
        </button>
      </div>
    </div>
  );
};

export default TopBar;
